import React, { useRef } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import { motion, useInView } from "framer-motion"; // Scroll animations
import { saleBannerData } from "../../../Data/data";
import { Link } from "react-router-dom";
import { buttonColor, buttonHoverColor, fontFamilyall } from "../../../UtilColorPalate/UtilColorPalate";

const SaleBanner = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { triggerOnce: true, threshold: 0.3 });

  return (
    <Box
      ref={sectionRef}
      sx={{
        position: "relative",
        padding: "60px 40px",
        borderRadius: "20px",
        overflow: "hidden",
      }}
    >
      <Grid container spacing={4} alignItems="center">
        {/* Left Side - Text Content */}
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            animate={isInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}
          >
            <Box
              sx={{
                textAlign: "left",
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <Typography
                variant="h2"
                fontWeight="bold"
                gutterBottom
                sx={{
                  fontFamily: fontFamilyall,
                  background: "black",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                {saleBannerData.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: "#444",
                  lineHeight: 1.8,
                  fontSize: "18px",
                  marginBottom: "20px",
                  fontWeight: 500,
                  fontFamily: fontFamilyall,
                }}
              >
                {saleBannerData.description}
              </Typography>

              {/* Call-to-Action Button */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 1, delay: 0.3 }}
              >
                <Link to="/shop">
                <Button
                  variant="contained"
                   sx={{
                                                 backgroundColor: buttonColor,
                                                 color: "#fff",
                                                 textTransform: "none",
                                                 padding: "5px 15px",
                                                 borderRadius: "4px",
                                                 "&:hover": { backgroundColor: buttonHoverColor },
                                                 fontFamily: fontFamilyall,
                                               }}
                >
                  Shop Now
                </Button>
                </Link>
               
              </motion.div>
            </Box>
          </motion.div>
        </Grid>

        {/* Right Side - Image Banner with Floating Animation */}
        <Grid item xs={12} md={6}>
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={isInView ? { opacity: 1, scale: 1 } : {}}
            transition={{ duration: 1, delay: 0.5 }}
          >
            <motion.img
              src={saleBannerData.image}
              alt="Sale Banner"
              animate={{ y: [0, -10, 0] }} // Floating up & down
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }} // Smooth infinite motion
              style={{
                width: "100%",
                height: "auto",
                borderRadius: "20px",
                boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.3)",
              }}
            />
          </motion.div>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SaleBanner;
